/** @typedef {'active' | 'background' | 'inactive'} AppStateStatus */

/** @return {AppStateStatus} */
const getAppState = () => 'active'

export default getAppState